<div>
  <div class="mb-4">
    <app-text class="text-secondary700 h2-strong">{{ locale?.liveclasses.liveclassTitle }}</app-text>
  </div>
  <div class="class-list">
    <app-liveclass-card *ngFor="let class of classes" [liveclass]="class" [locale]="locale" [usertype]="usertype" (clickenroll)="onClickEnroll($event)"></app-liveclass-card>
    <app-text *ngIf="classes?.length == 0" class="body-l text-c200">{{ locale?.liveclasses.noData }}</app-text>
  </div>
</div>
